/**
 * Created by Alan Yang on 5/15/2019.
 * Description:
 * Ag-grid private icon
  * ------ maintenance history ------
  * 06/16/2019 Bowen Li - add tooltip for smart-icon
 */

import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'tam-manage-screens-private-icon',
    template: `<smart-icon #anchor name='locked' class='smart-icon'></smart-icon>`,
    styleUrls: ['./manage-screens.component.scss']
})
export class ManageScreensPrivateIconComponent implements ICellRendererAngularComp {
    constructor(
    ) { }

    agInit(params: any): void {
    }

    refresh(): boolean {
        return false;
    }
}
